import { set } from "lodash";
export function populateData(state, action) {
    var data = action.payload;
    for (var fieldName in data) {
        set(state, fieldName, data[fieldName]);
    }
}
//# sourceMappingURL=populateData.js.map